import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Box, Button, Card, Text, Paragraph, Flex } from '@zillow/constellation';
import TextField from '../Fields/TextField.js';
import SelectField from '../Fields/SelectField.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import { calculatorDisclaimerText, FieldConfig } from './LoanComparison.utils.js';
import LoanComparisonResultForm from './LoanComparisonResultForm.js';
import LegalPopover from '../CalculatorForm/LegalPopover.js';

var LoanComparisonCardContent = function LoanComparisonCardContent(props) {
  return /*#__PURE__*/React.createElement(Box, {
    as: Card
    // To make the cards width fluid
    ,
    sx: {
      flex: 1
    },
    cardType: "secondary",
    cardElevation: 0
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "p",
    textAlign: "center",
    paddingBottom: "md"
  }, props.headingText), /*#__PURE__*/React.createElement(TextField, {
    label: "Loan amount",
    name: FieldConfig[props.loanType + 'LoanAmount'].name,
    leftAdornment: "$",
    config: FieldConfig[props.loanType + 'LoanAmount'].config,
    autoComplete: "off",
    required: true,
    format: commaSeparateNumber
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig[props.loanType + 'LoanTerm'].options,
    label: 'Loan term (years)',
    name: FieldConfig[props.loanType + 'LoanTerm'].name,
    required: true,
    config: FieldConfig[props.loanType + 'LoanTerm'].config
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Interest rate",
    rightAdornment: "%",
    name: FieldConfig[props.loanType + 'InterestRate'].name,
    config: FieldConfig[props.loanType + 'InterestRate'].config,
    required: true,
    autoComplete: "off",
    tooltip: {
      title: 'Interest rate',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "Representative interest rates are based upon a national, or state specific average from lenders quoting on Zillow for preliminary research purposes only. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics.")
    }
  }), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Flex, {
    marginRight: "xs",
    flex: "1"
  }, /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig[props.loanType + 'LoanStartMonth'].options,
    label: "Loan start date",
    required: true,
    name: FieldConfig[props.loanType + 'LoanStartMonth'].name,
    config: FieldConfig[props.loanType + 'LoanStartMonth'].config
  })), /*#__PURE__*/React.createElement(Flex, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig[props.loanType + 'LoanStartYear'].options,
    label: "",
    name: FieldConfig[props.loanType + 'LoanStartYear'].name,
    config: FieldConfig[props.loanType + 'LoanStartYear'].config
  }))));
};
function LoanComparisonFields() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    activeForm = _useState2[0],
    setActiveForm = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    as: LegalPopover,
    sx: {
      alignSelf: 'flex-end'
    },
    triggerText: "Calculator disclaimer",
    text: calculatorDisclaimerText
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: '$spacing.md',
      '@media $lg': {
        flexDirection: 'row'
      }
    }
  }, activeForm ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoanComparisonCardContent, {
    loanType: "typeOne",
    headingText: "Loan 1"
  }), /*#__PURE__*/React.createElement(LoanComparisonCardContent, {
    loanType: "typeTwo",
    headingText: "Loan 2"
  }), /*#__PURE__*/React.createElement(LoanComparisonCardContent, {
    loanType: "typeThree",
    headingText: "Loan 3"
  })) : /*#__PURE__*/React.createElement(LoanComparisonResultForm, null)), /*#__PURE__*/React.createElement(Box, {
    as: Button,
    buttonType: "primary",
    onClick: function onClick() {
      setActiveForm(!activeForm);
    },
    marginTop: "md",
    sx: {
      alignSelf: 'center'
    }
  }, activeForm ? 'View comparison' : 'New comparison'));
}

export { LoanComparisonCardContent, LoanComparisonFields as default };
